import { createFileRoute } from '@tanstack/react-router';

import { VirtualOfficesPage } from '@/features/virtual-offices';

export const Route = createFileRoute('/_app/virtual-offices/')({
  component: VirtualOfficesPage,
});
